import { render, staticRenderFns } from "./copyModal.vue?vue&type=template&id=65f8b1c8&"
import script from "./copyModal.vue?vue&type=script&lang=js&"
export * from "./copyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports